// extracted by mini-css-extract-plugin
export default {"directionTop":"directionTop--OLR20iCV","directionRight":"directionRight--P1v_ZZ8p","directionBottom":"directionBottom--uozQ_dIv","directionLeft":"directionLeft--MvaDu3Hu"};